
// 角色管理
<template>
	<div id="containt">
		<el-tabs v-model="activeName" class="tab-box" @tab-click="handleClick">
			<el-tab-pane label="常规" name="first">
				<editView v-if="showEdit" visible-key="showEdit" @resetEvent="resetEvent" :_dataId.sync="dataId"
					:parent-target="_self" @reload="$reloadHandle" @goBackIndex="goBackIndex"></editView>
			</el-tab-pane>
			<el-tab-pane label="列表" name="second">
				<div class="grid-height" >

					<div class="table_main" style="height: calc(100vh - -30px);">
						<vxe-grid ref="table-m1" show-overflow height="100%" :stripe="true" border="default" :row-config="{ isHover: true }"
							v-bind="vxeOption" @resizable-change="$vxeTableUtil.onColumnWitchChange"
							@custom="$vxeTableUtil.customHandle">

							<template #form>
								<div class="clearfix screen-btns">
									<div class="fl">
										<vxe-button status="primary" class="button-sty" icon="el-icon-plus"
											@click="openEditDialog">新增</vxe-button>
<!--                      <vxe-button status="primary" class="button-sty" icon="el-icon-top"-->
<!--                       @click="openEditDialog">导入-->
<!--              </vxe-button>-->
<!--              <vxe-button status="primary" class="button-sty" icon="el-icon-bottom"-->
<!--               @click="openEditDialog">导出-->
<!--              </vxe-button>-->
									</div>
									<div class="fr">
<!--										<vxe-button icon="el-icon-brush" class="button-sty" @click="resetEvent" type="text"-->
<!--											status="primary" plain>重置</vxe-button>-->
										<vxe-button status="warning" icon="el-icon-search" class="button-sty"
											@click="searchEvent">搜索</vxe-button>
									</div>
								</div>
								<vxe-form ref="form" class="screen-box" title-width="92px" title-align="right"
									:data="formData" @submit="toFilterData" @keyup.enter.native="toFilterData" @reset="searchEvent">
									<vxe-form-item title="角色名称:" field="brandName">
										<template v-slot>
											<el-input v-model="formData.roleName" size="small" clearable />
										</template>
									</vxe-form-item>
									<vxe-form-item title="角色标识:" field="itemCode">
										<template v-slot>
											<el-input v-model="formData.roleCode" size="small" clearable />
										</template>
									</vxe-form-item>
									<vxe-form-item title="菜单:" field="menuName">
										<template v-slot>
											<el-input v-model="formData.menuName" size="small" clearable  @clear="cleanId">
												<i slot="suffix" class="el-input__icon el-icon-search"
                           @click="handlePermission2()"></i>
											</el-input>
										</template>
									</vxe-form-item>
								</vxe-form>
							</template>
							<template #pager>
								<pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
							</template>


        <!-- <template #dsType="{ row }">
          <span class="txt-status2" v-if="row.dsType==0">全部</span>
          <span class="txt-status2" v-else-if="row.dsType==1">自定义</span>
          <span class="txt-status2" v-else-if="row.dsType==2">本级及子级</span>
          <span class="txt-status2" v-else-if="row.dsType==3">本级</span>
         <span v-else></span>
        </template> -->

						</vxe-grid>
					</div>
				</div>
			</el-tab-pane>
		</el-tabs>
    <el-dialog
    width="90%"
    style="position: absolute; top: 0px;background-color: rgb(38 38 38 / 70%);"
      :visible.sync="dialogPermissionVisible"
      :close-on-click-modal="false"
      title="分配权限"
       v-el-drag-dialog v-el-dialog-center
      :append-to-body="true" :modal-append-to-body="true"
      close-on-click-modal="false"  custom-class="dialog-style list-dialog">
      <div class="dialog-main-tree"  style="height: 900px;">
		<el-input
		style="margin-bottom: 8px;"
  placeholder="输入关键字进行过滤"
  v-model="filterText">
</el-input>
        <el-tree
          ref="menuTree"

          :data="treeData"
          :default-checked-keys="checkedKeys"
          :check-strictly="false"
          :props="defaultProps"
          :filter-node-method="filterNode"
          class="filter-tree"
          node-key="id"
          highlight-current
          show-checkbox
          />
      </div>
      <div slot="footer"
           class="dialog-footer">
        <el-button
          type="primary"
          size="small"
          @click="updatePermession(roleId)">更 新
        </el-button>
        <el-button
          type="default"
          size="small"
          @click="cancal()">取消
        </el-button>
      </div>
    </el-dialog>
<!-- 菜单 查看对应角色 弹框 -->
<div class="MnameD">
<el-dialog
    width="90%"
    style="position: absolute; top: 0px;background-color: rgb(38 38 38 / 70%);"
      :visible.sync="dialogPermissionVisible2"
      :close-on-click-modal="false"
      title="菜单选择"
       v-el-drag-dialog v-el-dialog-center
      :append-to-body="true" :modal-append-to-body="true"
      close-on-click-modal="false"  custom-class="dialog-style list-dialog">
      <div class="dialog-main-tree"  style="height: 900px;">
		<el-input
		style="margin-bottom: 8px;"
  placeholder="输入关键字进行过滤"
  v-model="filterText2">
</el-input>
        <el-tree
          ref="tree"

          :data="treeData"
          :default-checked-keys="checkedKeys"
		  show-checkbox
          check-strictly
          :props="defaultProps"
          :filter-node-method="filterNode"
          class="filter-tree"
          node-key="id"
          highlight-current
		  @check="handleClickMenu"
		@check-change="handleClickChange"
          />
      </div>
      <div slot="footer"
           class="dialog-footer">
        <el-button
          type="primary"
          size="small"
          @click="getMenuName">确 定
        </el-button>
        <el-button
          type="default"
          size="small"
          @click="cancal()">关 闭
        </el-button>
      </div>
    </el-dialog>
</div>
<!-- 查看 -->
	<lookOverDialog :visiable.sync="lookOver" @commit="closeLook" v-if="lookOver"  :menuID="menuID" ></lookOverDialog>

	</div>
</template>

<script>
import editView from './edit.vue';
import {indexPageMixins} from '@/mixins/tabChang'
import {initVxeTable} from '@/const/crud/admin/table';
// import {fetchTree} from "@/api/admin/dept";
import pager from '@/components/pager/index.vue'
import api from "@/api/projectApi";

import {fetchMenuTree} from '@/api/admin/menu'
import {addObj, delObj, fetchList, fetchRoleTree, permissionUpd, putObj} from '@/api/admin/role'
import lookOverDialog from './lookOverDialog.vue'




export default {
	name: 'role',

	inject: ['reload'],

  mixins: [indexPageMixins],
	components: { editView, pager,lookOverDialog },
	data() {
		return {
			Mname:'',
			MnameId:'',
			menuID:'',
			lookOver: false,
      dialogPermissionVisible: false,
      dialogPermissionVisible2: false,

      treeData: [],
      checkedKeys: [],
      roleId: undefined,
      roleCode: undefined,
      menuIds: '',



      total: 0,
			filterText: '',
			filterText2: '',

			data: [],
			defaultProps: {
				children: 'children',
				label: 'label',
				id: "id",
				isLeaf: "leaf"
			},
			pageSizes: [10, 20, 100],
			//以上树形
			activeName: 'second',
			dataId: 0,
			showEdit: false,
			vxeOption: {},
			// 查询参数
			formData: {
				current: 1,
				searchCount: false,
				// parentId: undefined,
        roleName: "",
				roleCode: "",
				menuName: "",
				menuId:null,
				bigCategoryId: null,
				smallCategoryId: null,
				id: null,
			},
		};
	},
	mounted() {
		// this.initTableList();
	},
	watch: {
		filterText(val) {
			this.$refs.menuTree.filter(val);
		},
		filterText2(val) {
			this.$refs.tree.filter(val);
		},
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
	},
	methods: {
		toFilterData() {
            this.searchEvent();
     },
		cleanId(){
			this.formData.menuId=null
		},
		handleClickMenu(data, tree) {
        this.$refs.tree.setCheckedKeys([]); // 删除所有选中节点
        this.$refs.tree.setCheckedNodes([data]); // 选中已选中节点
		console.log(data,'this.$refs.tree.setCheckedNodes([data])1111选的值');

    },
	handleClickChange(data, check, childCheck) {
      	if (check) {
       	 	this.$refs.tree.setCheckedNodes([data]); // 选中已选中节点
			console.log(data,'this.$refs.tree.setCheckedNodes([data])选的值');
			this.Mname=data.name
			this.MnameId=data.id


      	}
	},
	getMenuName(){
this.formData.menuName=this.Mname
this.formData.menuId=this.MnameId
console.log(this.formData.menuId,"选择的菜单ID");
		this.dialogPermissionVisible2= false

	},


		closeLook(){
      this.lookOver=false

    },
    lookOverS(e){
    console.log(e,'查看点击的ID');
      this.lookOver=true
      this.menuID=e
    },

		// 	// 请求总数
		// getNewCount(val){
		// 	console.log(val,"val的值--请求总数");
		// 	this.formData.searchCount=val
		// 	  this.$refs['table-m1'].commitProxy('reload');
		// },
		// // 不请求总数
		// getNewCount2(val){
		// 	console.log(val,"val的值--不请求总数");
		// 	this.formData.searchCount=val
		// 	  this.$refs['table-m1'].commitProxy('reload');
		// },
		// el-tab 监视切换事件
		handleClick(tab, event) {
			console.log(tab, event);

		},

		// 分页功能
		changeTablePage(page, flag) {
			console.log('分页数据', page, this.formData)
			this.formData.size = page.pageSize
			this.formData.current = page.currentPage
			this.formData.searchCount = flag
			this.getTableData();
		},

		filterNode(value, data) {
			if (!value) return true;
			console.log(value, data,"value, data搜索");
			return data.name.indexOf(value) !== -1;
		},
		// 搜索
		searchEvent() {
			this.$refs.pager.clearStoreTableDataTotal()
			this.formData.current = 1
			this.$refs['table-m1'].commitProxy('reload');

		},
		// 重置
		resetEvent() {
			this.formData = {};
			this.formData.addresswangdian = {};
			this.$refs.pager.reset()  // 重置分页器
			this.$refs['table-m1'].commitProxy('reload');
		},
		// 新增
		openEditDialog(id) {
			this.dataId = !id || typeof id == 'object' ? 0 : id;
			this.activeName = 'first';
			this.$openEditView('showEdit');
		},
		deletes(id) {
			// this.dataId = !id || typeof id == 'object' ? 0 : id;
			// this.activeName = 'first';
			// this.$openEditView('showEdit');
			console.log(id,"删除所选的ID");
			this.$baseConfirm('您确定要删除吗？').then(() => {
				this.$http({
                url: '/admin/role/'+id,
                method: `delete`,

              }).then(() => {
                   this.$message.success("删除成功！");
				   this.reload()

              }).catch(e => {
                // console.error(e)
                // this.$message.error("保存失败！");
              })

			})
		},
		handlePermission2() {
    //   console.log(id,"id 权限打开");
	  this.dialogPermissionVisible2= true
	  fetchMenuTree().then(response => {
          this.treeData = response.data.data
        })

    //   fetchRoleTree(id)
    //     .then(response => {
    //       this.checkedKeys = response.data.data

    //     })
        // .then(response => {
        //   this.treeData = response.data.data

        //   this.checkedKeys = this.resolveAllEunuchNodeId(this.treeData, this.checkedKeys, [])
        //   this.dialogPermissionVisible = true
        //   this.roleId = id

        // })
    },
    handlePermission(id) {
      console.log(id,"id 权限打开");
      fetchRoleTree(id)
        .then(response => {
          this.checkedKeys = response.data.data

          return fetchMenuTree()
        })
        .then(response => {
          this.treeData = response.data.data

          this.checkedKeys = this.resolveAllEunuchNodeId(this.treeData, this.checkedKeys, [])
          this.dialogPermissionVisible = true
          this.roleId = id
          // this.roleCode = row.roleCode
        })
    },
	    cancal() {
      this.dialogPermissionVisible = false;
		this.dialogPermissionVisible2= false

    },
        /**
     * 解析出所有的太监节点id
     * @param json 待解析的json串
     * @param idArr 原始节点数组
     * @param temp 临时存放节点id的数组
     * @return 太监节点id数组
     */
     resolveAllEunuchNodeId(json, idArr, temp) {
      for (let i = 0; i < json.length; i++) {
        const item = json[i]
        // 存在子节点，递归遍历;不存在子节点，将json的id添加到临时数组中
        if (item.children && item.children.length !== 0) {
          this.resolveAllEunuchNodeId(item.children, idArr, temp)
        } else {
          temp.push(idArr.filter(id => id === item.id))
        }
      }
      return temp
    },
    // 弹窗更新
    updatePermession(roleId) {
		console.log(roleId,"roleId权限弹窗打开的id");

      this.menuIds = ''
      this.menuIds = this.$refs.menuTree.getCheckedKeys().join(',').concat(',').concat(this.$refs.menuTree.getHalfCheckedKeys().join(','))
      permissionUpd(roleId, this.menuIds).then(() => {
        this.dialogPermissionVisible = false
		this.$mask.open()
        this.$nextTick(() => {

		this.$router.go(0)
		this.$mask.close()

	})

        this.$notify.success('修改成功')
      })
    },
    getTableData() {
			let that = this;
			let tableOption = {
				vue: this,
				tableRef: 'table-m1',
				tableName: 'basic_fault_code_list-m1',
				path: '/admin/role/getListPage',
        param: this.formData,
				method: 'post',

				columns: [
					{ type: 'seq', width: 60, title: '序号', resizable: false, fixed: 'left' },
					{
						title: '角色名称',
						field: 'roleName',
						width: 140,
						// fixed: 'left'
					},
					{
						title: '角色标识',
						field: 'roleCode',
						width: 150,
					},
					{
						title: '角色描述',
						field: 'roleDesc',
						width: 120,
					},
			// 		{
			// 			title: '数据权限',
			// 			field: 'dsType',
			// 			width: 120,
            // slots: { default: 'dsType' }
			// 		},


					{
						field: 'createTime',
						title: '创建时间',
						width: 180
					},

					{
						width: 150,
						fixed: 'right',
						title: '操作',
						sortable: false,
						slots: {
							default: ({ row }) => {
								return [
									<div>
										<a
											href="javascript:void(0);"
											class="a-link"
											onclick={() => {
												this.openEditDialog(row.roleId);
											}}
										>
											<el-tooltip enterable={false} effect="dark" content="查看" placement="top" popper-class="tooltip-skin">
												<i class="el-icon-edit" />
											</el-tooltip>
										</a>
                    <a
											href="javascript:void(0);"
											class="a-link"
											onclick={() => {
												this.deletes(row.roleId);
											}}
										>
											<el-tooltip enterable={false} effect="dark" content="删除" placement="top" popper-class="tooltip-skin">
												<i class="el-icon-delete" />
											</el-tooltip>
										</a>
                    <a
											href="javascript:void(0);"
											class="a-link"
											onclick={() => {
												this.handlePermission(row.roleId);
											}}
										>
											<el-tooltip enterable={false} effect="dark" content="添加权限" placement="top" popper-class="tooltip-skin">
												<i class="el-icon-circle-plus-outline" />
											</el-tooltip>
										</a>

										<a
											href="javascript:void(0);"
											class="a-link"
											onclick={() => {
												this.lookOverS(row.roleId);
											}}
										>
											<el-tooltip enterable={false} effect="dark" content="查看" placement="top" popper-class="tooltip-skin">
												<i class="el-icon-view" />
											</el-tooltip>
										</a>
									</div>
								];
							}
						}
					}
				]
			};
			// initVxeTable(tableOption).then(opts => {
			this.vxeOption = initVxeTable(tableOption);
			this.$refs['table-m1'].commitProxy('reload');
			// console.log(initVxeTable(tableOption),"vxeOption-表头的值及属性");
			// });
		},
		// 加载页面
		loadChildNode(node, resolve) {
			console.log(node, "loadChildNode.node")
      this.$http.post(api.userTree.getTree,{
        parentId: node.data.id,
        categoryType: 1
      }).then(({data}) => {
        console.log(data, "data.data的值")
        resolve(
          data.data.map(item => {
            return {
              label: item.name,
              id: item.id,
              leaf: Number(item.hasChild) == 1 ? false : true,
            }
          })
        )
      });
			// this.treeData=data.data


		},


	}
};
</script>
<style lang="scss" scoped>
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
	.el-radio__inner {
		border: 0px;
		background: transparent;
	}

	.el-radio__input.is-checked .el-radio__inner {
		background: none;
	}

	.el-radio {
		height: 100%;
		width: 150px;
		position: absolute;
		z-index: 10;
	}
}

.table_main {
	padding-top: 5px;
	padding-left: 5px;
	border: 1px solid #ededed;

	border-bottom: none;

	.el-pagination {
		padding: 2px;

	}
}

.left_tree {
	width: 205px;

	.title {
		text-align: left;
		width: 182px;
		padding: 7px 0 5px !important;
		font-size: 13px;
		color: rgba(58, 39, 39, 0.96);

		>span {
			position: relative;
			left: 4px;
			top: -3px;
		}
	}

	::v-deep.el-tree-node__label {
		width: calc(100% - 32px);
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		font-size: 12px;
		color: rgba(86, 86, 86, 0.96);
	}
}

.tree_icon {
	background: #f0f3ff;
}

// 重新修改tree组件样式
::v-deep.tree-line {
	.el-tree-node {
		position: relative;
		padding-left: 0px;
	}

	.el-tree-node__content {
		margin-top: 0px;
	}

	.el-tree-node__children {
		padding-left: 16px;
	}

	.el-tree-node::before {
		content: '';
		height: 100%;
		width: 1px;
		position: absolute;
		left: -3px;
		top: -26px;
		border-width: 1px;
		border-left: 1px dashed #d9d9d9;
	}

	.el-tree-node:last-child::before {
		height: 38px;
	}

	.el-tree-node::after {
		content: '';
		width: 24px;
		height: 1px;
		position: absolute;
		left: -3px;
		top: 12px;
		border-width: 1px;
		border-top: 1px dashed #d9d9d9;
	}

	&>.el-tree-node::after {
		border-top: none;
	}

	&>.el-tree-node::before {
		border-left: none;
	}

	.el-tree-node__expand-icon {
		font-size: 17px;

		// color: #000;
		&.is-leaf {
			color: transparent;
			// display: none;
		}
	}
}
::v-deep .vxe-grid .a-link {
    margin-right: -3px !important;
}
.el-dialog__wrapper {
  .el-dialog {
    // width: 61% !important;

    .dialog-main-tree {
      max-height: 350px;
      overflow-y: auto;
    }
  }

  .el-form-item__label {
    width: 20% !important;
    padding-right: 20px;
  }

  .el-form-item__content {
    margin-left: 20% !important;
  }
}
.MnameD ::v-deep .el-checkbox__inner{
      	border-radius: 50%;
    }
</style>

